import { render, staticRenderFns } from "./image1.vue?vue&type=template&id=1cb7cb3a&scoped=true"
import script from "./image1.vue?vue&type=script&lang=js"
export * from "./image1.vue?vue&type=script&lang=js"
import style0 from "./image1.vue?vue&type=style&index=0&id=1cb7cb3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb7cb3a",
  null
  
)

export default component.exports